export const keyCodeConstant = {
  UP: 'ArrowUp',
  DOWN: 'ArrowDown',
  LEFT: 'ArrowLeft',
  RIGHT: 'ArrowRight',
  ESC: 'Escape',
  ENTER: 'Enter',
};
